import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";

import storage from "@/utils/storage";

Vue.use(Vuex);

let token = "";
let areaId = "";
let openId = "";
let likedIds = [];
let activeIdx = 1;
try {
  token = storage.get("token") || "";
  areaId = storage.get("areaId") || "";
  openId = storage.get("openId") || "";
  //@ts-ignore
  likedIds = storage.get("likedIds") || [];
  //@ts-ignore
  activeIdx = storage.get("activeIdx") || 1;
} catch (e) {
  console.error(e);
}
console.log(process.env.NODE_ENV);
// 测试
if (!token && process.env.NODE_ENV === "development") {
  token =
    "eyJhbGciOiJIUzUxMiJ9.eyJyYW5kb21LZXkiOiIyYnc2bXciLCJzdWIiOiJ3ZWImJiYxIiwiYXJlYUlkIjoiNjEwNTIzIiwib2ZmaWNlSWQiOiJyb290IiwiZXhwIjoxNzUzNDM2NDQ5LCJpYXQiOjE3NTI4MzE2NDl9.y1ckHUzEOB-on1A6fdgFctTFO6uxKVR-Y2Srwo6gzjLa1aOKEQIDrhc3ZNREDfLaiLj8jIqWbJfwqcT-Tqwfhg";
}

export default new Vuex.Store({
  state: {
    token,
    current: {},
    managerInfo: {},
    areaId,
    areaList: [],
    openId,
    likedIds: [],
    activeIdx: 1,
  },
  mutations: {
    login(state: any, tokenStr: string) {
      state.token = tokenStr;
      storage.set("token", tokenStr);
    },
    logout(state: any) {
      state.token = null;
      state.current = null;
      storage.remove("token");
    },
    setOpenId(state: any, openId: string) {
      state.openId = openId;
      storage.set("openId", openId);
    },
    setCurrent(state: any, current: any) {
      state.current = current;
    },
    setManagerInfo(state: any, managerInfo: any) {
      state.managerInfo = managerInfo;
    },
    setAreaId(state: any, areaIdStr: string) {
      state.areaId = areaIdStr;
      if (areaIdStr) {
        storage.set("areaId", areaIdStr);
      } else {
        storage.remove("areaId");
      }
    },
    setAreaList(state: any, areaList: any[]) {
      state.areaList = areaList;
    },
    setLikedIds(state: any, likedIds: any[]) {
      state.likedIds = likedIds;
      storage.set("likedIds", likedIds);
    },
    setActiveIdx(state: any, activeIdx: any[]) {
      state.activeIdx = activeIdx;
      storage.set("activeIdx", activeIdx);
    },
  },
});
